/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type { EventNFT, EventNFTInterface } from "../../contracts/EventNFT";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_eventOwner",
        type: "address",
      },
      {
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        internalType: "string",
        name: "tokenSymbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "_tokenURI",
        type: "string",
      },
      {
        internalType: "uint16",
        name: "_maxTokens",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "_currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint96",
        name: "_royaltyPercentage",
        type: "uint96",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
    ],
    name: "burnToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "commonTokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currency",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "eventOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxTokens",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
    ],
    name: "mintToken",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintedCount",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "royaltyPercentage",
    outputs: [
      {
        internalType: "uint96",
        name: "",
        type: "uint96",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type EventNFTConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: EventNFTConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class EventNFT__factory extends ContractFactory {
  constructor(...args: EventNFTConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _eventOwner: PromiseOrValue<string>,
    tokenName: PromiseOrValue<string>,
    tokenSymbol: PromiseOrValue<string>,
    _tokenURI: PromiseOrValue<string>,
    _maxTokens: PromiseOrValue<BigNumberish>,
    _currency: PromiseOrValue<string>,
    _price: PromiseOrValue<BigNumberish>,
    _royaltyPercentage: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<EventNFT> {
    return super.deploy(
      _eventOwner,
      tokenName,
      tokenSymbol,
      _tokenURI,
      _maxTokens,
      _currency,
      _price,
      _royaltyPercentage,
      overrides || {}
    ) as Promise<EventNFT>;
  }
  override getDeployTransaction(
    _eventOwner: PromiseOrValue<string>,
    tokenName: PromiseOrValue<string>,
    tokenSymbol: PromiseOrValue<string>,
    _tokenURI: PromiseOrValue<string>,
    _maxTokens: PromiseOrValue<BigNumberish>,
    _currency: PromiseOrValue<string>,
    _price: PromiseOrValue<BigNumberish>,
    _royaltyPercentage: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _eventOwner,
      tokenName,
      tokenSymbol,
      _tokenURI,
      _maxTokens,
      _currency,
      _price,
      _royaltyPercentage,
      overrides || {}
    );
  }
  override attach(address: string): EventNFT {
    return super.attach(address) as EventNFT;
  }
  override connect(signer: Signer): EventNFT__factory {
    return super.connect(signer) as EventNFT__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EventNFTInterface {
    return new utils.Interface(_abi) as EventNFTInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): EventNFT {
    return new Contract(address, _abi, signerOrProvider) as EventNFT;
  }
}
